export default "__VITE_ASSET__3oomrGWV__"